import React, { CSSProperties } from 'react';

interface ArrowDownTrayProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const ArrowDownTray: React.FC<ArrowDownTrayProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50">
        <path d="M530 634.2V300.2" />
        <polyline points="393 497 530 634 667 497" />
      </g>
      <path d="M311.2 634.8v92.5c0 18 14.6 32.5 32.5 32.5h372.5c18 0 32.5-14.6 32.5-32.5v-92.5" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50" />
    </svg>
  );
};

export default ArrowDownTray;
